import React, { useState } from 'react'
import Modal from 'components/modal'
import ICSelect from 'containers/project-creation/create-view/select'
import 'less/edit-interview-or-moderator-buffer-modal.less'

const EditInterviewOrModeratorBufferModal = props => {
  const isPostScreeninModal = props.flag === "postScreeninBuffer"
  const [value, setValue] = useState(isPostScreeninModal ? parseInt(props.currentProject.postScreeninBuffer) : parseInt(props.moderatorBuffer))

  return (
    <Modal
      title={`${isPostScreeninModal ? props.t('edit.post.screenin.buffer.title') : props.t('edit.moderator.buffer.title')}`}
      isOpen={props.isOpen}
      className="edit-advanced-options-modal"
      type="modal"
      autoFocusSubmit={false}
      submitBtnText="Save and Confirm"
      onCancel={props.onClose}
      onSubmit={() => props.onSubmit({ "value": value, "flag": props.flag, "projectId":props.currentProject.id, moderatorId:props.singleModerator.id, clientId: props.singleModerator.clientId, lastUpdatedOn: Date.now()  })}
      isSubmitting={props.isSubmitting}
      enableSubmit={isPostScreeninModal ? value !== parseInt(props.currentProject.postScreeninBuffer) : value !==  parseInt(props.moderatorBuffer)}
    >
      <p>
        {isPostScreeninModal ?
          props.t('post.screenin.buffer.message')
          :
          props.t('moderator.buffer.message')}
      </p>
      <div className='edit-advanced-options-container'>
        <ICSelect
          title={isPostScreeninModal ? props.t('post.screenin.buffer.title') : props.t('moderator.buffer.title')}
          options={isPostScreeninModal ?
            [2, 4, 6, 8, 12, 18, 24, 48, 72, 96, 120].map(value => ({ value, label: `${value} Hours ${value === 24 ? "(Default)" : value > 24 ? "(" + value / 24 + " Days)" : ""}` }))
            :
            [15, 30, 45, 60].map(value => ({ value, label: `${value} minutes  ${value === 15 ? "(Default)" : ''}` }))
          }
          value={value}
          onChange={({ value }) => setValue(value)}
          name="advancedOptions"
        />
      </div>
    </Modal>
  )
}

export default EditInterviewOrModeratorBufferModal
